import { Routes, Route, Navigate } from 'react-router-dom'
import Landing from './pages/Landing'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Counseling from './pages/Counseling'
import History from './pages/History'
import Profile from './pages/Profile'
import LuckyToday from './pages/features/LuckyToday'
import Compatibility from './pages/features/Compatibility'
import CharacterCard from './pages/features/CharacterCard'
import CelebrityMatch from './pages/features/CelebrityMatch'
import JobRecommend from './pages/features/JobRecommend'
import FoodToday from './pages/features/FoodToday'
import DaeunAnalysis from './pages/features/DaeunAnalysis'
import LuckyDate from './pages/features/LuckyDate'
import DreamInterpretation from './pages/features/DreamInterpretation'
import YearlyReport from './pages/features/YearlyReport'
import NameAnalysis from './pages/features/NameAnalysis'
import GroupCompatibility from './pages/features/GroupCompatibility'
import CardShare from './pages/CardShare'
import WriteReview from './pages/WriteReview'
import WriteInquiry from './pages/WriteInquiry'
import MyInquiries from './pages/MyInquiries'
import AdminInquiries from './pages/AdminInquiries'
import AdminUsage from './pages/AdminUsage'
import { useAuthStore } from './store/authStore'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/counseling" element={<PrivateRoute><Counseling /></PrivateRoute>} />
      <Route path="/history" element={<PrivateRoute><History /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />

      <Route path="/features/lucky-today" element={<PrivateRoute><LuckyToday /></PrivateRoute>} />
      <Route path="/features/compatibility" element={<PrivateRoute><Compatibility /></PrivateRoute>} />
      <Route path="/features/character-card" element={<PrivateRoute><CharacterCard /></PrivateRoute>} />
      <Route path="/features/celebrity-match" element={<PrivateRoute><CelebrityMatch /></PrivateRoute>} />
      <Route path="/features/job-recommend" element={<PrivateRoute><JobRecommend /></PrivateRoute>} />
      <Route path="/features/food-today" element={<PrivateRoute><FoodToday /></PrivateRoute>} />
      <Route path="/features/daeun" element={<PrivateRoute><DaeunAnalysis /></PrivateRoute>} />
      <Route path="/features/lucky-date" element={<PrivateRoute><LuckyDate /></PrivateRoute>} />
      <Route path="/features/dream-interpretation" element={<PrivateRoute><DreamInterpretation /></PrivateRoute>} />
      <Route path="/features/yearly-report" element={<PrivateRoute><YearlyReport /></PrivateRoute>} />
      <Route path="/features/name-analysis" element={<PrivateRoute><NameAnalysis /></PrivateRoute>} />
      <Route path="/features/group-compatibility" element={<PrivateRoute><GroupCompatibility /></PrivateRoute>} />

      <Route path="/review" element={<PrivateRoute><WriteReview /></PrivateRoute>} />
      <Route path="/inquiry/new" element={<PrivateRoute><WriteInquiry /></PrivateRoute>} />
      <Route path="/inquiries" element={<PrivateRoute><MyInquiries /></PrivateRoute>} />
      <Route path="/admin/inquiries" element={<PrivateRoute><AdminInquiries /></PrivateRoute>} />
      <Route path="/admin/usage" element={<PrivateRoute><AdminUsage /></PrivateRoute>} />

      <Route path="/card/:token" element={<CardShare />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

